/*
  repX cart boost: defines <repx-cutoff-timer> on every page so the 48-hour
  delivery countdown also ticks inside the cart drawer (including when the
  drawer content is re-rendered after add to cart). Same logic as the inline
  definition in snippets/cart-summary.liquid (cart page); whichever loads first wins.
*/
(function () {
  if (!window.customElements || customElements.get('repx-cutoff-timer')) return;

  class RepxCutoffTimer extends HTMLElement {
    connectedCallback() {
      window.clearInterval(this.interval);
      this.units = {
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };
      this.swaps = this.querySelectorAll('[data-open][data-closed]');
      this.cutoff =
        (parseInt(this.dataset.cutoffHour, 10) || 0) * 3600 + (parseInt(this.dataset.cutoffMinute, 10) || 0) * 60;
      this.formatter = null;
      try {
        this.formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.dataset.timezone || 'Asia/Karachi',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });
      } catch (error) {
        this.formatter = null;
      }
      this.state = null;
      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    secondsSinceMidnight() {
      var now = new Date();
      if (this.formatter) {
        var h = 0, m = 0, s = 0;
        this.formatter.formatToParts(now).forEach(function (part) {
          if (part.type === 'hour') h = parseInt(part.value, 10) % 24;
          else if (part.type === 'minute') m = parseInt(part.value, 10);
          else if (part.type === 'second') s = parseInt(part.value, 10);
        });
        return h * 3600 + m * 60 + s;
      }
      return (Math.floor(now.getTime() / 1000) + 5 * 3600) % 86400;
    }

    tick() {
      var remaining = this.cutoff - this.secondsSinceMidnight();
      var open = remaining > 0;
      if (!open) remaining += 86400;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      if (this.units.hours) this.units.hours.textContent = pad(Math.floor(remaining / 3600));
      if (this.units.minutes) this.units.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
      if (this.units.seconds) this.units.seconds.textContent = pad(remaining % 60);
      this.classList.toggle('is-closed', !open);
      var state = open ? 'open' : 'closed';
      if (state !== this.state) {
        this.state = state;
        this.swaps.forEach(function (el) {
          el.textContent = open ? el.dataset.open : el.dataset.closed;
        });
      }
    }
  }

  customElements.define('repx-cutoff-timer', RepxCutoffTimer);
})();
